export const COMPONENTLOAD_FAILURE = 'componentLoad.failure';
